export default __webpack_public_path__ + "static/media/SignUpImage.6ed49e85.svg";